"use client";

import React from "react";
import { AppWindow, ArrowUpRight, Globe, Wrench } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "The Hull Polish",
  description: "Our signature professional exterior restoration and high-gloss wax finishing designed to protect your vessel from the elements.",
  icon: AppWindow,
  highlights: ["HIGH-GLOSS", "UV PROTECTION", "MIRROR FINISH"]
}, {
  title: "Interior Detailing",
  description: "Deep cleaning of cabins, upholstery, and deck surfaces for a pristine, showroom-quality experience every time you step on board.",
  icon: Globe,
  highlights: ["MILDEW TREATMENT", "OXIDATION REMOVAL", "STAIN EXTRACTION"]
}, {
  title: "Exterior Detailing",
  description: "Complete exterior cleaning of the hull, deck, and cockpit to restore a spotless, polished look and protect your boat from harsh marine conditions.",
  icon: ArrowUpRight,
  highlights: ["HYDROPHOBIC LAYER", "9H HARDNESS", "MACHINE POLISHING\n"]
}, {
  title: "Maintenance Wash",
  description: "Regular scheduled cleaning to keep your vessel in peak condition throughout the boating season.",
  icon: Wrench,
  highlights: ["BIODEGRADABLE SOAP", "WATERLINE SCRUB", "STAINLESS POLISHING"]
}];
export default function DevelopmentSpectrum() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="147442" id="marine-care-packages" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-[0.03] mix-blend-overlay pointer-events-none"></div>
      
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        <div className={`max-w-3xl mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-4xl md:text-6xl font-default font-bold tracking-tight text-foreground mb-6">
            Marine Care Packages
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed">
            Engineered for precision and longevity. We provide comprehensive detailing services that restore your vessel's brilliance and protect its value against the harsh marine environment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div data-index={i} key={i} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full bg-card/40 backdrop-blur-xl border-border/30 rounded-sm transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_50px_-12px_rgba(34,211,238,0.15)] hover:border-primary/40 group overflow-hidden relative">
                  {}
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-secondary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>
                  
                  <CardHeader className="pb-4 relative z-10">
                    <div className="size-14 rounded-sm bg-background/60 border border-border/40 flex items-center justify-center mb-6 group-hover:bg-primary/5 group-hover:border-primary/20 transition-all duration-500 shadow-sm">
                      <Icon className="size-7 text-primary" strokeWidth={1} />
                    </div>
                    <CardTitle className="text-2xl font-default font-semibold tracking-tight mb-2">
                      {service.title}
                    </CardTitle>
                    <CardDescription className="text-base font-sans leading-relaxed text-muted-foreground">
                      {service.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="relative z-10">
                    <div className="flex flex-wrap gap-2 pt-2">
                      {service.highlights.map((highlight, j) => <Badge data-index={j} key={j} variant="outline" className="bg-background/20 border-border/30 text-[10px] tracking-widest uppercase font-sans text-muted-foreground group-hover:border-primary/20 group-hover:text-foreground transition-colors duration-300 py-1 px-3 rounded-sm">
                          {highlight}
                        </Badge>)}
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}